<template>
  <b-card id="cashflows" no-body v-if="Object.keys(collateralCashflow).length != 0">
    <b-card-header header-tag="header" class="p-0 mt-1">
      <b-btn block href="#" variant="info" class="text-left">Collateral Cashflow</b-btn>
    </b-card-header>
    <b-collapse visible>
      <table class="table table-sm table-hover">
        <thead>
          <th class="sticky">Period</th>
          <!-- <th class="text-right sticky">Payment<br/> Date</th> -->
          <th class="text-right sticky">Balance</th>
          <th class="text-right sticky">Gross Interest</th>
          <th class="text-right sticky">Net Interest</th>
          <th class="text-right sticky">Scheduled<br/> Principal</th>
          <th class="text-right sticky">Prepaid<br/> Principal</th>
          <th class="text-right sticky">Defaults</th>
          <th class="text-right sticky">Losses</th>
          <th class="text-right sticky">Recoveries</th>
          <th class="text-right sticky">Delinquency</th>
          <th class="text-right sticky">Libor</th>
        </thead>
        <tbody>
          <tr v-for="(item, index) in collateralCashflow.Balance" :key=index>
            <td>{{index}}</td>
            <!-- <td class="text-right text-nowrap">{{row.PaymentDate}}</td> -->
            <td class="text-right">{{collateralCashflow.Balance[index]}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.Interest[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.PassThru[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.ScheduledPrincipal[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.PrepaidPrincipal[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.Defaults[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.Losses[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.Recoveries[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.Delinquency[index])}}</td>
            <td class="text-right">{{skipFirstRow(index, collateralCashflow.Libor[index])}}</td>
          </tr>
        </tbody>
      </table>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  props: {
    collateralCashflow: Object
  },
  methods: {
    skipFirstRow(index, value) {
      return index != 0 ? value : ''
    }
  }
}
</script>